// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconAnnotationsAnnotationOn_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s16IconSvg = html `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M8.5 0H7.5L7.03681 1.15796C5.85243 1.55923 5 2.68007 5 4C5 4.61337 5.18408 5.18374 5.5 5.6589V9H4V11H5.5V13L7.5 16V11H8.5V16L10.5 13V11H12V9H10.5V5.6589C10.8159 5.18374 11 4.61337 11 4C11 2.68007 10.1476 1.55923 8.96319 1.15796L8.5 0ZM8.5 6.95852V9H7.5V6.95852C7.6626 6.9858 7.82964 7 8 7C8.17036 7 8.3374 6.9858 8.5 6.95852ZM9 4C9 4.55228 8.55228 5 8 5C7.44772 5 7 4.55228 7 4C7 3.44772 7.44772 3 8 3C8.55228 3 9 3.44772 9 4Z" class="svg-bg"/>
</svg>
`;
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M13 1H11L10.2294 3.3117C8.90844 3.93764 8 5.24215 8 6.75C8 7.72218 8.37764 8.60983 9 9.28558V14.4167H7V16.3333H9V19.4L11 24V16.3333H13L13 24L15 19.4L15 16.3333H17V14.4167H15L15 9.28558C15.6224 8.60983 16 7.72218 16 6.75C16 5.24215 15.0916 3.93764 13.7706 3.3117L13 1ZM13 14.4167H11V10.4626C11.3196 10.5414 11.6547 10.5833 12 10.5833C12.3453 10.5833 12.6804 10.5414 13 10.4626L13 14.4167ZM12 8.83333C13.1046 8.83333 14 7.9379 14 6.83333C14 5.72876 13.1046 4.83333 12 4.83333C10.8954 4.83333 10 5.72876 10 6.83333C10 7.9379 10.8954 8.83333 12 8.83333Z" class="svg-bg"/>
</svg>
`;
/**
 * IconAnnotationsAnnotationOn is a generated icon component.
 */
let IconAnnotationsAnnotationOn = IconAnnotationsAnnotationOn_1 = class IconAnnotationsAnnotationOn extends IconBaseElement {
    render() {
        return html `${IconAnnotationsAnnotationOn_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconAnnotationsAnnotationOn.icons = new Map([
    ['s8', _s16IconSvg],
    ['s12', _s16IconSvg],
    ['s16', _s16IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconAnnotationsAnnotationOn = IconAnnotationsAnnotationOn_1 = __decorate([
    customElement('zui-icon-annotations-annotation-on')
], IconAnnotationsAnnotationOn);
export { IconAnnotationsAnnotationOn };
